import { useEffect, useState } from 'react';

export const SEARCH_DEBOUNCE_MS = 500;

/**
 * Returns `value` once it has stopped changing for `delay` ms.
 * Use it to drive API calls / filtering from a search input so we don't
 * fire on every keystroke.
 */
export const useDebounce = <T,>(value: T, delay: number = SEARCH_DEBOUNCE_MS): T => {
  const [debouncedValue, setDebouncedValue] = useState<T>(value);

  useEffect(() => {
    const timer = setTimeout(() => setDebouncedValue(value), delay);
    return () => clearTimeout(timer);
  }, [value, delay]);

  return debouncedValue;
};
